module.exports = __webpack_public_path__ + "img/scene_entity.f1ae60e5.png";